import Assignments from "../../../components/Admin/Assignments";
import Navbar from "../../../components/Navbar";

export default function AssignmentPage() {
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <Assignments />
        </div>
      </section>
    </>
  );
}
